import Vue from 'vue';
import {asyncQueryAction} from '@/store/util/store-utils';
import {UserApi} from '@/api/user';

const mutationTypes = Object.freeze({
  SET_B2B_UNIT: 'setB2bUnit',
  FETCH_USER_REQUEST: 'FETCH_USER_REQUEST',
  FETCH_USER_FAILURE: 'FETCH_USER_FAILURE',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
});

const mutations = {
  [mutationTypes.SET_B2B_UNIT](state, value) {
    Vue.set(state, 'b2bUnit', value);
  },
  [mutationTypes.FETCH_USER_REQUEST](state) {
    state.isUserDataLoading = true;
  },
  [mutationTypes.FETCH_USER_SUCCESS](state, value) {
    state.isUserDataLoading = false;
    state.customer = value;
  },
  [mutationTypes.FETCH_USER_FAILURE](state) {
    state.isUserDataLoading = false;
    state.customer = {};
  },
};

const actions = {
  loadCurrentUser({commit}) {
    const loadUserData = async () => {
      const userData = (await UserApi.getCustomerData())?.data?.data;
      return userData;
    };
    asyncQueryAction(
      loadUserData,
      mutationTypes.FETCH_USER_REQUEST,
      mutationTypes.FETCH_USER_SUCCESS,
      mutationTypes.FETCH_USER_FAILURE
    ).run({commit});
  },
};

const user = {
  namespaced: true,

  state: {
    b2bUnit: {},
    loggedIn: window.ACC.userLoggedIn || false,
    customer: {},
    isUserDataLoading: false,
  },

  mutations: mutations,
  actions: actions,
};

export default user;
